import apiReducer from 'src/shared/reducers/api_data';

import { RELOAD } from './actions';

export default apiReducer({
  successActions: [ RELOAD ],
});
